import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import {
  fetchCombinedCompanyData,
  type CompanyDataResult,
} from "@/services/company-data-service";
import { processCuiInput } from "@/utils/cui-utils";

export function useFetchCompanyData(): UseMutationResult<
  CompanyDataResult,
  Error,
  { cui: string },
  unknown
> {
  return useMutation({
    mutationFn: async ({ cui }: { cui: string }) => {
      const cuiProcessing = processCuiInput(cui);
      if (!cuiProcessing.isValid) {
        return {
          success: false,
          error: cuiProcessing.error || "CUI invalid",
        } as CompanyDataResult;
      }

      const result = await fetchCombinedCompanyData(cui);
      if (!result.success) {
        throw new Error(result.error || "Eroare la preluarea datelor");
      }
      return result;
    },
  });
}
